import React from "react";
import { Link } from "react-router-dom";

const switchRolesAnswer = (
  <>
    Yes. Go to{" "}
    <Link to="/account?tab=switch">Account Settings → Switch Account</Link>{" "}
    and choose the role you'd like to move to — Student, Tutor, or Training
    Centre. Switching to Tutor or Training Centre requires admin review
    before it takes effect, since we verify credentials for every provider
    on the platform. Your existing profile and history are kept when you
    switch.
  </>
);

export const faqData = {
  student: [
    {
      q: "What is TutorsLinks?",
      a: "TutorsLinks is an online platform that connects students with verified tutors and training centres for academic and skills-based learning — both online and in-person.",
    },
    {
      q: "How do I find a tutor or training centre?",
      a: "Use the 'Search' button to filter by subject, skill, location, price, or rating. You can view tutor profiles, compare options, and contact them directly via the in-app chat.",
    },
    {
      q: "How do I register as a student?",
      a: "Click 'Create Account', select 'Student', and complete your details. You’ll need your name, email, phone number, and preferred location. Once registered, you can search for tutors or centres that match your needs.",
    },
    {
      q: "Can I book online or in-person lessons?",
      a: "Yes. You can choose Online, In-Person, or Hybrid options depending on your preference and the tutor’s availability.",
    },
    {
      q: "Are tutors verified?",
      a: "Yes. All tutors and centres undergo a strict verification process which may include ID validation, academic certificates checks, and profile review before approval.",
    },
    {
      q: "Can I leave reviews?",
      a: "Yes! After a session, you can rate your tutor and leave feedback. Your review helps others make informed decisions and promotes tutor accountability.",
    },
    {
      q: "Do I need to be 18 or older to use TUTORSLINKS?",
      a: "Students under 18 can register with parental or guardian consent and supervision.",
    },
    {
      q: "Is there a mobile app?",
      a: "Yes. You can access TutorsLinks via our mobile app or directly through www.tutorslinks.com. You can also download the app from the App Store or Google Play Store. For more information, visit www.tutorslinks.com",
    },
    {
      q: "How do I pay for lessons?",
      a: "All payments are made outside the Platform but in case made through the platform, it is secured through using trusted processors(e.g. Paystack, Flutterwave)",
    },
    {
      q: "What if I'm not satisfied with a class?",
      a: "You can request for a refund under our refund and cancellation policy. Report any issues through your dashboard or email support@tutorslinks.com",
    },
    {
      q: "How do I communicate with my tutor or centre?",
      a: "Use only the official Tutorslinks chat or call features for all communications with your tutor or centre. Avoid sharing personal contact information until necessary.",
    },
    {
      q: "What should I do if I feel unsafe or uncomfortable?",
      a: "Immediately report the issue to support@tutorslinks.com or use the in-app 'Report'. All reports are treated confidentially under our Child Protection and Safeguarding Policy.",
    },
    {
      q: "Can I access lessons from outside Nigeria?",
      a: "Yes. TutorsLinks supports both local and international users, though availability may vary by Tutor or Training Center.",
    },
    {
      q: "Can I switch between Student, Tutor, and Training Centre profiles?",
      a: switchRolesAnswer,
    },
  ],
  tutor: [
    {
      q: "How do I become a tutor or training centre?",
      a: "Click 'Create Account', select 'Tutor/Training Centre', fill in your profile, and upload required documents (valid ID, qualifications, etc.). Your account will be reviewed and verified by our team before approval.",
    },
    {
      q: "What documents are required for verification?",
      a: "Valid ID (e.g., National ID, Passport, or Driver’s License), Relevant academic or professional certificates, Business registration (for training centres), Profile photo and course/program description/lists, etc.",
    },
    {
      q: "How long does verification take?",
      a: "Verification typically takes 1–5 working days (we are trying to make it shorter to within few hours, minutes or even immediate, depending on document completeness)",
    },
    {
      q: "Can I teach online and offline?",
      a: "Yes. You can choose your preferred mode of teaching — online, in-person, or hybrid — during registration.",
    },
    {
      q: "Can I set my own fees?",
      a: "Yes. Tutors and centres have full control over pricing, subject to platform guidelines  and fairness policies.",
    },
    {
      q: "Are there fees for using TutorsLinks?",
      a: "No. Onboarding and students’ connects are free. But Tutors can decide to upgrade their listing via Premium services for more visibility or promotion.",
    },
    {
      q: "Can my account be suspended?",
      a: "Yes. Accounts may be suspended or permanently closed for violations of the Terms of Use, Code of Conduct, or Child Protection Policy.",
    },
    {
      q: "How do I close my account?",
      a: "You can deactivate or delete your account at any time by contacting 'support@tutorslinks.com'.",
    },
    {
      q: "How do I list my courses or Programs?",
      a: "After registration, go to your 'Dashboard' and click on 'Add Course/Program',  fill in details (title, description, duration, price, etc.), and publish once approved.",
    },
    {
      q: "How do I get students?",
      a: "Students find you through search filters (subject, skill, or location). Ensure your profile is complete, with a clear photo, description, and positive reviews to attract more learners.",
    },
    {
      q: "How do I receive payments?",
      a: "Payments from students are made outside TutorsLinks platform to your account as agreed with the student. No payment come from student to TutorsLinks.",
    },
    {
      q: "What happens if I miss or cancel a class?",
      a: "Tutors must provide at least 24 hours’ notice to students to cancel or reschedule a class. Repeated cancellations without valid reason may lead to account suspension. Failure to show up without notice may result in non-payment or penalties. ",
    },
    {
      q: "What's the Tutor or Training Center Code of Conduct?",
      a: "All tutors and centres must maintain professionalism, respect, honesty and safety in every session. Any violation — including misconduct, fraud, or harassment — will result in disciplinary action, including suspension or termination.",
    },
    {
      q: "Can I communicate directly with Students outside TutorsLinks?",
      a: "Yes. Initial communications can commence from the TutorLinks platform, further communication can proceed outside the platform, especially for physical classes.",
    },
    {
      q: "Can I teach multiple subjects or skills?",
      a: "Yes! You can offer as many verified courses or programs as you are qualified to teach, subject to our platform policies and guidelines.",
    },
    {
      q: "What support does TutorsLinks provide?",
      a: "TutorsLinks offers: Marketing and visibility to reach new students. Verified badges and promotion. Dispute resolution support. Ongoing training on professionalism and digital teaching tools.",
    },
    {
      q: "How do I report an issue or dispute?",
      a: "Use the “Report” button in your dashboard or contact 'support@tutorslinks.com'. Our 'Dispute Resolution Team' will review and respond promptly.",
    },
    {
      q: "Can I switch between Student, Tutor, and Training Centre profiles?",
      a: switchRolesAnswer,
    },
  ],
};
